export default {
    // 用户相关 getters
    isAuthenticated: state => state.user.isAuthenticated
  }